import Logo from "assets/images/Logo.png";
import LoginBackground from "assets/images/sign-login.png";
import RightArrow from "assets/images/RightArrow.png";
import Union from "assets/images/Union.png";
import Dashboard from "assets/images/Dashboard.svg";
import Admin from "assets/images/Admin.svg";
import PoSystem from "assets/images/POSystem.svg";
import NissanSupplierReleaseSystem from "assets/images/NissanSupplierReleaseSystem.svg";
import Loader from "assets/images/Loader.gif";
import PegaLogo from "assets/images/SmallLogo.png";
import DetailsView from "assets/images/view-details.png";
import Edit from "assets/images/Edit.svg";
import SupplierPO from "assets/images/supplyPO.svg";
import ExcelPreview from "assets/images/EXCEL Preview.svg";
import PngPreview from "assets/images/PNG Preview.svg"
import PdfPreview from "assets/images/PDF Preview.svg";
import JpgPreview from "assets/images/JPEG.svg";
import TiffPreview from "assets/images/TIFF.svg";
import ActivityDetails from "assets/images/Activity Details.svg" ;
import TimeOut from "assets/images/TimeOut.svg";
import NotFound from "assets/images/nothing-found.jpg";

export const LogoIcon = Logo;
export const LoginBackgroundIcon = LoginBackground;
export const RightArrowIcon = RightArrow;
export const UnionIcon = Union;
export const DashboardIcon = Dashboard;
export const AdminIcon = Admin;
export const PoSystemIcon = PoSystem;
export const NissanSupplierIcon = NissanSupplierReleaseSystem;
export const LoaderIcon = Loader;
export const PegasusLogoIcon = PegaLogo;
export const EditIcon = Edit;
export const detailsView = DetailsView;
export const SupplierPOIcon = SupplierPO;
export const ActivityDetailsIcon = ActivityDetails;
export const PdfPreviewIcon = PdfPreview;
export const TimeOutIcon = TimeOut;
export const NotFoundIcon = NotFound;
export const ExcelPreviewIcon = ExcelPreview;
export const ImagePngPreviewIcon = PngPreview;
export const ImageJpgPreviewIcon = JpgPreview;
export const ImageTiffPreviewIcon = TiffPreview;